import { render, staticRenderFns } from "./relic-detail-repair.vue?vue&type=template&id=c8520178"
import script from "./relic-detail-repair.vue?vue&type=script&lang=js"
export * from "./relic-detail-repair.vue?vue&type=script&lang=js"
import style0 from "./relic-detail-repair.vue?vue&type=style&index=0&id=c8520178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports